export default "__VITE_ASSET__BaQrbcQr__"